import { Tunings } from "fretboards";

export const namespaced = true;

export const state = {
  tuning: Tunings.guitar6.standard,
  leftHanded: false
};

export const getters = {};

export const mutations = {
  SET_TUNING(state, tuning) {
    state.tuning = tuning;
  },
  SET_LEFTHANDED(state, leftHanded) {
    state.leftHanded = leftHanded;
  }
};

export const actions = {
  async setPreferences({ commit }, preferences) {
    commit("SET_TUNING", preferences.tuning);
    commit("SET_LEFTHANDED", preferences.leftHanded);
  },
  async setLeftHanded({ commit }, leftHanded) {
    commit("SET_LEFTHANDED", leftHanded);
  },
  async setTuning({ commit }, tuning) {
    commit("SET_TUNING", tuning);
  }
};
